var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { DocEditorBlockSpecs } from '@blocksuite/blocks';
import { noop } from '@blocksuite/global/utils';
import { EditorHost, ShadowlessElement, WithDisposable } from '@blocksuite/lit';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { createRef, ref } from 'lit/directives/ref.js';
noop(EditorHost);
let DocEditor = class DocEditor extends WithDisposable(ShadowlessElement) {
    constructor() {
        super(...arguments);
        this.specs = DocEditorBlockSpecs;
        this.host = createRef();
    }
    render() {
        return html `
      <style>
        doc-editor * {
          box-sizing: border-box;
        }
        doc-editor {
          display: block;
          height: 100%;
          position: relative;
          overflow: hidden;
          font-family: var(--affine-font-family);
          background: var(--affine-background-primary-color);
        }
        @media print {
          doc-editor {
            height: auto;
          }
        }
      </style>
      <editor-host
        ${ref(this.host)}
        .page=${this.page}
        .specs=${this.specs}
      ></editor-host>
    `;
    }
};
__decorate([
    property({ attribute: false })
], DocEditor.prototype, "page", void 0);
__decorate([
    property({ attribute: false })
], DocEditor.prototype, "specs", void 0);
DocEditor = __decorate([
    customElement('doc-editor')
], DocEditor);
export { DocEditor };
//# sourceMappingURL=doc-editor.js.map